import { Marker, MeetingResponse } from '@/types.d';
import { mapMeeting } from '@/src/helpers/mapMeeting';
import { CompassContextType } from '@/src/libs/CompassContext';

import { groupMeetingsByAddress } from './groupMeetingsByAddress';
import { buildMarker } from './buildMarker';
import { sortAndCenterNewMarkers } from './sortAndCenterNewMarkers';

export const createMarkersFromFetchedData = async (
  data: MeetingResponse[],
  ctx: CompassContextType
): Promise<Marker[]> => {
  if (!data.length) throw new Error('No meetings provided');
  if (!ctx) throw new Error('No context provided');
  const collectMarkers: Marker[] = [];

  const groupedMeetings = groupMeetingsByAddress(data);

  // @ts-expect-error AdvancedMarkerElement exists in library
  const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

  for (const value of groupedMeetings) {
    if (!value) continue;

    const meetings = value.map((meeting) =>
      mapMeeting(meeting as MeetingResponse)
    );

    const marker = buildMarker({
      class: AdvancedMarkerElement ?? null,
      coords: meetings[0].coords,
      ctx,
      id: meetings.map((cur) => cur.id).toString(),
      meetings,
      map: ctx.state.map!,
    });

    if (marker) collectMarkers.push(marker);
  }

  const sortedMarkers = sortAndCenterNewMarkers(collectMarkers, ctx);

  return sortedMarkers;
};
